module.exports = __webpack_public_path__ + "img/AF.e2be7951.svg";